import { createFileRoute } from '@tanstack/react-router';

// Bare landing — buyers always arrive via /r/:publicId. This page exists so
// dev navigation has a home.
function IndexPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 text-center">
      <h1 className="text-2xl font-semibold text-[var(--color-navy-900)]">Caratuva buyer portal</h1>
      <p className="mt-2 text-[var(--color-navy-600)]">
        Open the link from your invoice email to continue.
      </p>
    </div>
  );
}

export const Route = createFileRoute('/')({
  component: IndexPage,
});
